import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';

/**
 * Component display e-giftcard information with title and description
 *
 *
 * @attr { String } [egift-card-info-title] - title of the information
 * @attr { String } [egift-card-info-desc] - description of the e-giftcard
 * HTML Structure Example
 *
 * <e2-wishlist-product-info
 *      egift-card-info-title="Title"
 *      egift-card-info-desc="some description"
 * </e2-wishlist-product-info>
 *
 * */

export class WishlistEgiftCardInfo extends SimpleLitElement {
    static get properties() {
        return {
            egiftCardInfoTitle: {
                type: String,
                attribute: 'egift-card-info-title',
            },
            egiftCardInfoDesc: {
                type: String,
                attribute: 'egift-card-info-desc',
            },
        };
    }

    render() {
        return html`
            <div class="egiftcard-details">
                <div class="egiftcard-details__title">
                    ${this.egiftCardInfoTitle}
                </div>
                <div class="egiftcard-details__desc">
                    ${this.egiftCardInfoDesc}
                </div>
            </div>
        `;
    }
}

export default () => customElements.define('e2-wishlist-egiftcard-info', WishlistEgiftCardInfo);
